const Config = {
	X_AXIS_LABEL: "Performance",
	Y_AXIS_LABEL: "Potential",
};

export default Config;
